var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { useKanbanDispatch } from "./context";
var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var isSelected = _a.isSelected, width = _a.width, top = _a.top, left = _a.left;
    return "\n    cursor: pointer;\n    position: ".concat(isSelected ? "absolute" : "static", ";\n    width: ").concat(width, ";\n    top: ").concat(top, "px;\n    left: ").concat(left, "px;\n");
});
export var KanbanCard = function (_a) {
    var children = _a.children, id = _a.id, /*tag,*/ width = _a.width;
    var kanbanDispatch = useKanbanDispatch();
    var _b = useState(false), isSelected = _b[0], setSelected = _b[1];
    var _c = useState({ top: 0, left: 0 }), _d = _c[0], top = _d.top, left = _d.left, setPosition = _c[1];
    var handleMouseMove = useCallback(function (e) {
        console.log(e.clientX, e.clientY);
        setPosition({ top: e.clientY - 5, left: e.clientX - 5 });
    }, []);
    useEffect(function () {
        if (isSelected) {
            window.addEventListener("mousemove", handleMouseMove);
        }
        else {
            window.removeEventListener("mousemove", handleMouseMove);
        }
        return function () { return window.removeEventListener("mousemove", handleMouseMove); };
    }, [isSelected, handleMouseMove]);
    var handleMouseDown = useCallback(function (e) {
        setSelected(true);
        setPosition({ top: e.clientY - 5, left: e.clientX - 5 });
        kanbanDispatch({ type: "HANDLE_MOUSE_DOWN_CARD", payload: id });
    }, [kanbanDispatch, id]);
    var handleMouseUp = useCallback(function (e) {
        console.log({ e: e });
        setSelected(false);
        kanbanDispatch({ type: "HANDLE_MOUSE_UP_CARD" });
    }, [kanbanDispatch]);
    return (React.createElement(Card, { onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, isSelected: isSelected, width: width, top: top, left: left }, children));
};
var templateObject_1;
